import { getSupportCenterDomain } from '@va/dashboard/selectors/customization';
import { useTranslate } from '@va/localization';
import { Button, Paragraph, paragraphSizes } from '@va/ui/design-system';
import { useSelector } from 'react-redux';
import { SettingsHeading } from '../misc';

type ResetDataCardComponentProps = {
  disabled: boolean;
  onClick: () => void;
  tooltip?: string;
};

export const ResetDataCardComponent = ({ disabled, onClick, tooltip }: ResetDataCardComponentProps) => {
  const translate = useTranslate();
  const supportCenterDomain = useSelector(getSupportCenterDomain);

  return (
    <div>
      <SettingsHeading
        title={translate('card.resetData.title')}
        subText={translate('card.deleteData.l1')}
        tooltip={translate('card.deleteData.tooltip', { supportCenterDomain })}
      />
      <Button
        disabled={disabled}
        tooltip={tooltip}
        onClick={onClick}
        color='tertiary'
        className='text-red-pure w-full mt-4'
        text={translate('card.resetData.button')}
      />
      <Paragraph size={paragraphSizes.tiny} className='text-center mt-1 text-gray-charcoal'>
        {translate('card.resetData.warning')}
      </Paragraph>
    </div>
  );
};
